import { jsx as _jsx } from "react/jsx-runtime";
import { DateInput as HeroDateInput } from '@heroui/react';
export const DateInput = (props) => {
    return _jsx(HeroDateInput, { ...props });
};
export default DateInput;
//# sourceMappingURL=DateInput.js.map